import React from 'react'
import ProjectCarouselButtons from '../ProjectCarouselButtons'

const WeatherForecast = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsweatherforecast" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/WeatherForecast/WeatherForecast.mp4" type="video/mp4" />
                                </video>
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/WeatherForecast/WeatherForecast.png" className="d-block w-100" alt="..." />
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="weatherforecast" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">WeatherForecast</p>
                            <p className="Project--info--subheading">FullStack Web Development</p>
                            <p className="Project--info--subheading">Using MERN Stack & WeatherApi</p>
                            <p className="Project--info--Para">Discover real-time and future weather predictions with our user-friendly Weather Forecast WebApp. Get detailed information on temperature, precipitation, wind speed, and more for any location, ensuring you stay informed about atmospheric conditions.</p>
                            <p className="Project--info--Para">Stay ahead of the elements with our intuitive Weather Forecast WebApp. Offering comprehensive details on temperature, precipitation, wind speed, and more, this tool provides accurate and timely meteorological information for precise locations or broader regions.</p>
                        </div>
                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/Weather-Forecast" target='__blank'>Github</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>GeoApi</p>
                            <p>RapidApi</p>
                            <p>React.js</p>
                            <p>Html/Css </p>
                            <p>Javascript</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WeatherForecast